import { __decorate, __extends } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SunRating from './sun-rating.vue';
var RatingMobile = /** @class */ (function (_super) {
    __extends(RatingMobile, _super);
    function RatingMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isVisible = false;
        return _this;
    }
    RatingMobile.prototype.closestElementByClass = function (el, selector, stopSelector) {
        var retval = null;
        while (el) {
            if (el.className.indexOf(selector) > -1) {
                retval = el;
                break;
            }
            else if (stopSelector && el.className.indexOf(stopSelector) > -1) {
                break;
            }
            el = el.parentElement;
        }
        return retval;
    };
    RatingMobile.prototype.mounted = function () {
        var _this = this;
        var self = this;
        var rating = this.$refs.ratingmobile;
        var parentSlide = this.closestElementByClass(rating, 'glide__slide', 'loaded');
        if (parentSlide) {
            var observer = new MutationObserver(function (mutations) {
                if (self.isInViewport()) {
                    self.isVisible = true;
                }
            });
            var config = {
                attributes: true
            };
            observer.observe(parentSlide, config);
        }
        if (this.isInViewport()) {
            this.isVisible = true;
        }
        setTimeout(function () {
            if (_this.isInViewport()) {
                _this.isVisible = true;
            }
        }, 200);
        document.addEventListener('scroll', function () {
            if (self.isInViewport()) {
                self.isVisible = true;
            }
        });
    };
    Object.defineProperty(RatingMobile.prototype, "ratingValueWithOneDecimal", {
        get: function () {
            return this.ratingValue.toFixed(1).replace('.', ',');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RatingMobile.prototype, "roundedRecommendationValue", {
        get: function () {
            return this.recommendationValue > 0 ? Math.round(this.recommendationValue) : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RatingMobile.prototype, "customerRatingLabelFullDynamic", {
        get: function () {
            return this.customerRecommendationValue === 1 ? this.customerRatingLabelFullSingle : this.customerRatingLabelFull;
        },
        enumerable: false,
        configurable: true
    });
    RatingMobile.prototype.triggerHolidayCheckButton = function () {
        if (this.isHotelOverview) {
            document.getElementById('holidaycheck_button').click();
        }
    };
    RatingMobile.prototype.isInViewport = function () {
        var element = this.$refs.ratingmobile;
        if (element) {
            var rect = element.getBoundingClientRect();
            return rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 44;
        }
        return false;
    };
    __decorate([
        Prop()
    ], RatingMobile.prototype, "isHotelCard", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "isHotelOverview", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "isLink", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "ratingValue", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "recommendationValue", void 0);
    __decorate([
        Prop({ default: "%" })
    ], RatingMobile.prototype, "recommendationSymbol", void 0);
    __decorate([
        Prop({ default: "Kundenbew." })
    ], RatingMobile.prototype, "customerRatingLabel", void 0);
    __decorate([
        Prop({ default: "Kundenbewertungen" })
    ], RatingMobile.prototype, "customerRatingLabelFull", void 0);
    __decorate([
        Prop({ default: "Kundenbewertung" })
    ], RatingMobile.prototype, "customerRatingLabelFullSingle", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "customerRecommendationLabel", void 0);
    __decorate([
        Prop({ default: "Weiterempfehlung" })
    ], RatingMobile.prototype, "customerRecommendationLabelFull", void 0);
    __decorate([
        Prop()
    ], RatingMobile.prototype, "customerRecommendationValue", void 0);
    RatingMobile = __decorate([
        Component({
            components: {
                SunRating: SunRating
            }
        })
    ], RatingMobile);
    return RatingMobile;
}(Vue));
export default RatingMobile;
